import { render, staticRenderFns } from "./batch-detail.vue?vue&type=template&id=f93c5e64&"
import script from "./batch-detail.vue?vue&type=script&lang=js&"
export * from "./batch-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports